import React, { useState } from 'react';
import API from '../utils/api';
import Swal from 'sweetalert2';
import '../pages/Dashboard.css';

const GENDER_OPTIONS = ['Laki-laki', 'Perempuan'];
const AGAMA_OPTIONS = ['Islam', 'Kristen', 'Katolik', 'Hindu', 'Buddha', 'Khonghucu'];
const GOL_DARAH_OPTIONS = ['A', 'B', 'AB', 'O', 'Tidak Tahu'];

export default function ProfileModal({ onComplete }) {
  const [form, setForm] = useState({
    name: '',
    gender: '',
    phone: '',
    tgl_lahir: '',
    suku: '',
    agama: '',
    gol_darah: '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    setError('');

    if (
      !form.name.trim() ||
      !form.gender ||
      !form.phone.trim() ||
      !form.tgl_lahir ||
      !form.suku.trim() ||
      !form.agama ||
      !form.gol_darah
    ) {
      setError('Semua field wajib diisi.');
      return;
    }

    setSaving(true);
    try {
      await API.post('/candidate/profile', form);
      Swal.fire({
        icon: 'success',
        title: 'Berhasil',
        text: 'Profil berhasil disimpan',
        timer: 1500,
        showConfirmButton: false,
      });
      onComplete();
    } catch (err) {
      setError(err.response?.data?.message || 'Gagal menyimpan profil');
    } finally {
      setSaving(false);
    }
  };

  return (
  <div className="profile-modal-box">
    <div className="profile-modal-header">
      <h2>Lengkapi Profil Anda</h2>
    </div>

    <div className="profile-modal-body">
      <p className="profile-modal-subtitle">
        Sebelum melanjutkan, silakan lengkapi data profil Anda terlebih dahulu.
      </p>

      {error && <div className="psy-error">{error}</div>}

      <div className="form-group">
        <label>Nama Lengkap</label>
        <input
          type="text"
          value={form.name}
          onChange={(e) => handleChange('name', e.target.value)}
          placeholder="Nama lengkap sesuai KTP"
        />
      </div>

      <div className="form-group">
        <label>Jenis Kelamin</label>
        <select
          value={form.gender}
          onChange={(e) => handleChange('gender', e.target.value)}
        >
          <option value="">Pilih Jenis Kelamin</option>
          {GENDER_OPTIONS.map((g) => (
            <option key={g} value={g}>{g}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Nomor Telepon</label>
        <input
          type="tel"
          value={form.phone}
          onChange={(e) => handleChange('phone', e.target.value)}
          placeholder="08xxxxxxxxxx"
        />
      </div>

      <div className="form-group">
        <label>Tanggal Lahir</label>
        <input
          type="date"
          value={form.tgl_lahir}
          onChange={(e) => handleChange('tgl_lahir', e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>Suku</label>
        <input
          type="text"
          value={form.suku}
          onChange={(e) => handleChange('suku', e.target.value)}
          placeholder="Contoh: Jawa, Sunda, Batak"
        />
      </div>

      <div className="form-group">
        <label>Agama</label>
        <select
          value={form.agama}
          onChange={(e) => handleChange('agama', e.target.value)}
        >
          <option value="">Pilih Agama</option>
          {AGAMA_OPTIONS.map((a) => (
            <option key={a} value={a}>{a}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Golongan Darah</label>
        <select
          value={form.gol_darah}
          onChange={(e) => handleChange('gol_darah', e.target.value)}
        >
          <option value="">Pilih Golongan Darah</option>
          {GOL_DARAH_OPTIONS.map((gd) => (
            <option key={gd} value={gd}>{gd}</option>
          ))}
        </select>
      </div>

      <div className="form-actions">
        <button
          className="btn-primary"
          onClick={handleSubmit}
          disabled={saving}
          style={{ width: '100%' }}
        >
          {saving ? 'Menyimpan...' : 'Simpan & Lanjutkan'}
        </button>
      </div>
    </div>
  </div>
);
}